import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../print-document-menu-item';
import { useOrderSummary } from '../hooks/use-order-summary';

export const OrderSummary = ({ printSetting, fulfillmentPlans }) => {
  const { isDisabled, onPrint } = useOrderSummary({ fulfillmentPlans });

  const defaultPrintSetting = useMemo(() => buildDefaultPrintSetting(printSetting, onPrint, onPrint), [onPrint, printSetting]);

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.OrderSummary.documentNameTranslation}
      onClick={onPrint}
    />
  );
};

OrderSummary.propTypes = {
  printSetting: PropTypes.any,
  fulfillmentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentPlanId: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
